/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Changelog_TitleInputs */

const id_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan perubahan`)
};

const ms_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log perubahan`)
};

const da_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringslog`)
};

const de_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsprotokoll`)
};

const en_us2_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_es2_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de cambios`)
};

const es_mx2_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de cambios`)
};

const fil_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan ng Pagbabago`)
};

const fr_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

const it_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro modifiche`)
};

const hu_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változásnapló`)
};

const nl_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslogboek`)
};

const no_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringslogg`)
};

const pl_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziennik zmian`)
};

const pt_br2_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de alterações`)
};

const pt_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo de alterações`)
};

const ro_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurnal modificări`)
};

const fi_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosloki`)
};

const sv_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringslogg`)
};

const vi_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký thay đổi`)
};

const tr_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Günlüğü`)
};

const cs_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn`)
};

const bg_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дневник на промените`)
};

const ru_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений`)
};

const uk_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін`)
};

const ar_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التغييرات`)
};

const hi_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव लॉग`)
};

const th_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลง`)
};

const ja_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴`)
};

const zh_cn2_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日志`)
};

const zh_hant1_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日誌`)
};

const ko_items_changelog_title = /** @type {(inputs: Items_Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Items_Changelog_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_changelog_title = /** @type {((inputs?: Items_Changelog_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Changelog_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_changelog_title(inputs)
	if (locale === "ms") return ms_items_changelog_title(inputs)
	if (locale === "da") return da_items_changelog_title(inputs)
	if (locale === "de") return de_items_changelog_title(inputs)
	if (locale === "en-US") return en_us2_items_changelog_title(inputs)
	if (locale === "es-ES") return es_es2_items_changelog_title(inputs)
	if (locale === "es-MX") return es_mx2_items_changelog_title(inputs)
	if (locale === "fil") return fil_items_changelog_title(inputs)
	if (locale === "fr") return fr_items_changelog_title(inputs)
	if (locale === "it") return it_items_changelog_title(inputs)
	if (locale === "hu") return hu_items_changelog_title(inputs)
	if (locale === "nl") return nl_items_changelog_title(inputs)
	if (locale === "no") return no_items_changelog_title(inputs)
	if (locale === "pl") return pl_items_changelog_title(inputs)
	if (locale === "pt-BR") return pt_br2_items_changelog_title(inputs)
	if (locale === "pt") return pt_items_changelog_title(inputs)
	if (locale === "ro") return ro_items_changelog_title(inputs)
	if (locale === "fi") return fi_items_changelog_title(inputs)
	if (locale === "sv") return sv_items_changelog_title(inputs)
	if (locale === "vi") return vi_items_changelog_title(inputs)
	if (locale === "tr") return tr_items_changelog_title(inputs)
	if (locale === "cs") return cs_items_changelog_title(inputs)
	if (locale === "bg") return bg_items_changelog_title(inputs)
	if (locale === "ru") return ru_items_changelog_title(inputs)
	if (locale === "uk") return uk_items_changelog_title(inputs)
	if (locale === "ar") return ar_items_changelog_title(inputs)
	if (locale === "hi") return hi_items_changelog_title(inputs)
	if (locale === "th") return th_items_changelog_title(inputs)
	if (locale === "ja") return ja_items_changelog_title(inputs)
	if (locale === "zh-CN") return zh_cn2_items_changelog_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_changelog_title(inputs)
	return ko_items_changelog_title(inputs)
});
export { items_changelog_title as "items.changelog.title" }